import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'jhi-silent-refresh',
    standalone: true,
    imports: [],
    templateUrl: './silent-refresh.component.html',
})
export class SilentRefreshComponent implements OnInit {

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        const params = this.route.snapshot.queryParamMap;
        const code   = params.get('code');
        const state  = params.get('state');
        const error  = params.get('error');

        // Post the result to the parent window, then close
        if (window.opener) {
            window.opener.postMessage(
                { type: 'AUTH_CALLBACK', code, state, error },
                window.location.origin
            );
            window.close();
        }
    }

}
